module.exports = require("type-graphql");